import cookie from "js-cookie";

export const getApiBaseUrl = () => getUrl("apiBaseUrl");

function getUrl(id, raiseEmpty = true) {
  return "/api/";
  // const el = document.getElementById(id);
  // if (!el) {
  //   throw new Error(`没有找到URL配置的HTML节点: #${id}`);
  // }

  // const url = el.innerHTML.trim();
  // if (raiseEmpty && !url) {
  //   throw new Error(`URL配置的HTML节点不可为空: #${id}`);
  // }

  // return url;
}

export function setCookie(name, value, { expireDays = 1 } = {}) {
  cookie.set(name, value, {
    expires: expireDays,
  });
}

export function getCookie(name) {
  return cookie.get(name, {
    path: "/",
  });
}

export function removeCookie(name) {
  cookie.remove(name, {
    path: "/",
  });
}

export function resolveDownloadUrl(id, fileName = "") {
  const baseUrl = getApiBaseUrl();
  const encodedFileName = encodeURIComponent(fileName);
  return `${baseUrl}Download/GetFile?id=${id}&fileName=${encodedFileName}`;
}

export function resolveSrcUrl(id) {
  const baseUrl = getApiBaseUrl();
  const http = window.location.origin;
  return `${http}${baseUrl}Download/GetSDSingleFiles?id=${id}`;
}

export function resolveFileUrl(id, name, download = false) {
  name = encodeURIComponent(name);
  const origin = window.location.origin;
  return `${origin}/file/${id}/${name}?download=${download}`;
}

export function resolveBizFileUrl(file, download = false) {
  return resolveFileUrl(file.FileId, file.FileName, download);
}
